
































import Vue from "vue";
import * as themeHelper from "../helpers/theme.helper";

export default Vue.extend({
  name: "Navbar",
  data: function() {
    return {
      collapsed: false
    }
  },
  computed: {
    currentPage() {
      return this.$route.path;
    },
  },
  methods: {
    cycleThemes: function () {
      themeHelper.cycleThemes();
    },

    collapse: function() {
      this.collapsed = !this.collapsed;
    }
  },
});
